import React from "react";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  IconButton,
  Paper,
  Typography,
  Box,
} from "@mui/material";
import { fetchWelcomeWizardCampaign,fetchAppCampaignWelcomeWizardStatus,deleteCampaignNameWelcomeWizard } from "../../Services/redux/Welcome-wizard/WelcomeWizardActions";
import DeleteIcon from "@mui/icons-material/Delete";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ApplicationsListDialog from "./ApplicationsListDialog";
import DeleteCampaignDialog from "./DeleteCampaignDialog";

// Helper to format date
function formatDate(ms) {
  const d = new Date(ms);
  return d.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    timeZone: "UTC",
  });
}

function CampaignsTable({ campaignData }) {
  const dispatch = useDispatch();
    const [openApplicationList, setOpenApplicationList] = React.useState(false);
    const [openDeleteDialog, setOpenDeleteDialog] = React.useState(false);
    const [campaignNameToDelete, setCampaignNameToDelete] = React.useState("");
    const CampaignNameCampaignData = useSelector((state) => state.welcomeWizard.CampaignNameCampaignData);

    const getTheAppsList = (row) => {
      dispatch(fetchAppCampaignWelcomeWizardStatus(row.name));
      setOpenApplicationList(true);
    }

    const callDeleteDialog = (campaignName) => {
      dispatch(fetchAppCampaignWelcomeWizardStatus(campaignName));
      setCampaignNameToDelete(campaignName);
      setOpenDeleteDialog(true);
    }

    const onDeleteCampaignName=()=>{
      dispatch(deleteCampaignNameWelcomeWizard(campaignNameToDelete));
      setOpenDeleteDialog(false);
    }

    const closeTheApplicationDialog=()=>{
      setOpenApplicationList(false);
      dispatch(fetchWelcomeWizardCampaign());
    }

  return (
    <>
    <Box sx={{ mt: 2 }}>
      <Typography variant="h6" sx={{ mb: 2, fontWeight: 500 }}>
        Campaigns
      </Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead
            sx={{
              backgroundColor: "#E8E8E8",
            }}
          >
            <TableRow>
              <TableCell
                sx={{
                  fontFamily: "Roboto",
                  fontWeight: 600,
                  fontSize: 14,
                  letterSpacing: "0.4px",
                }}
              >
                Campaign Name
              </TableCell>
              <TableCell
                sx={{
                  fontFamily: "Roboto",
                  fontWeight: 600,
                  fontSize: 14,
                  letterSpacing: "0.4px",
                }}
              >
                No. of Apps
              </TableCell>
              <TableCell
                sx={{
                  fontFamily: "Roboto",
                  fontWeight: 600,
                  fontSize: 14,
                  letterSpacing: "0.4px",
                }}
              >
                Campaign Duration
              </TableCell>
              <TableCell align="right"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            { campaignData && campaignData.length > 0 ? campaignData.map((row) => (
              <TableRow key={row.name}>
                <TableCell>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Typography
                      sx={{
                         fontFamily: "Roboto",
                         fontWeight: row.default ? 700 : 400,
                         mr: row.default ? 1 : 0,
                         letterSpacing: "0.25px",
                        color: row.default ? "#2A2C2D":"#5A5B5C",
                        textDecoration:row.default ? "underline":"none"
                      }}
                    >
                      {row.name}
                    </Typography>
                    {row.default && (
                      <Chip
                        label="Default Campaign"
                        sx={{
                          background: "#E0E0E0",
                          color: "#222",
                          fontWeight: 500,
                          fontSize: "12px",
                          borderRadius: "6px",
                          height: "24px",
                          ml: 1,
                        }}
                        size="small"
                      />
                    )}
                  </Box>
                </TableCell>
                <TableCell
                  sx={{
                    fontFamily: "Roboto",
                    fontWeight: 400,
                    fontSize: 14,
                    letterSpacing: "0.25px",
                    color: "#5A5B5C",
                  }}
                >
                  {row.noOfApps}
                </TableCell>
                <TableCell
                  sx={{
                    fontFamily: "Roboto",
                    fontWeight: 400,
                    fontSize: 14,
                    letterSpacing: "0.25px",
                    color: "#5A5B5C",
                  }}
                >
                  {formatDate(row.startDate)}  {row.endDate ? '- ' + formatDate(row.endDate) : ""}
                </TableCell>
                <TableCell align="right">
                  {row.default ? (
                    <IconButton size="small" onClick={() => getTheAppsList(row)}>
                      <ChevronRightIcon fontSize="small" />
                    </IconButton>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-end",
                        gap: "8px",
                      }}
                    >
                      <IconButton size="small" onClick={() => callDeleteDialog(row.name)}>
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                      <IconButton size="small" onClick={() => getTheAppsList(row)}>
                        <ChevronRightIcon fontSize="small" />
                      </IconButton>
                    </div>
                  )}
                </TableCell>
              </TableRow>
            ))
            :
            (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  No Campaigns Available
                </TableCell>
              </TableRow>
            )
          }
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
     {CampaignNameCampaignData && Object.keys(CampaignNameCampaignData).length > 0 &&
    <ApplicationsListDialog open={openApplicationList} CampaignAppData={CampaignNameCampaignData} onClose={closeTheApplicationDialog} />
          }
    <DeleteCampaignDialog open={openDeleteDialog} CampaignAppData={CampaignNameCampaignData} onClose={() => setOpenDeleteDialog(false)} onDelete={onDeleteCampaignName} />
    </>
  );
}

CampaignsTable.propTypes = {
  campaignData: PropTypes.array,
};

export default CampaignsTable;
